<template>
  <div>
    <v-dialog persistent v-model="show" max-width="1000">
      <v-card>
        <v-card-title class="headline">{{
          tipoClientex.substring(0, tipoClientex.length - 1)
        }}</v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" xl="6">
                <v-text-field
                  :error-messages="aliasErrors"
                  @input="$v.objetoCliente.Alias.$touch()"
                  @blur="$v.objetoCliente.Alias.$touch()"
                  v-model="objetoCliente.Alias"
                  autofocus
                  dense
                  autocomplete="new"
                  label="Alias"
                ></v-text-field>
              </v-col>
              <v-col cols="12" xl="6">
                <v-text-field
                  :error-messages="nombreC_Errors"
                  @input="$v.objetoCliente.Nombre_Completo.$touch()"
                  @blur="$v.objetoCliente.Nombre_Completo.$touch()"
                  v-model="objetoCliente.Nombre_Completo"
                  dense
                  autocomplete="new"
                  label="Nombre completo"
                ></v-text-field>
              </v-col>
              <!-- TODO -->
              <v-col cols="12" xl="6">
                <v-text-field
                  :error-messages="razonS_Errors"
                  @input="$v.objetoCliente.Razon_Social.$touch()"
                  @blur="$v.objetoCliente.Razon_Social.$touch()"
                  v-model="objetoCliente.Razon_Social"
                  dense
                  autocomplete="new"
                  label="Razón social"
                ></v-text-field>
              </v-col>
              <v-col cols="12" xl="6">
                <v-text-field
                  :error-messages="emailErrors"
                  @input="$v.objetoCliente.Email.$touch()"
                  @blur="$v.objetoCliente.Email.$touch()"
                  v-model="objetoCliente.Email"
                  dense
                  autocomplete="new"
                  label="Email"
                ></v-text-field>
              </v-col>
              <v-col cols="12" xl="6">
                <v-text-field
                  :error-messages="telefonoErrors"
                  @input="$v.objetoCliente.Telefono.$touch()"
                  @blur="$v.objetoCliente.Telefono.$touch()"
                  v-model="objetoCliente.Telefono"
                  dense
                  autocomplete="new"
                  label="Teléfono"
                ></v-text-field>
              </v-col>
              <v-col cols="12" xl="6">
                <v-text-field
                 
                  v-model="objetoCliente.TaxId"
                  dense
                  autocomplete="new"
                  label="RFC/TAX ID"
                ></v-text-field>
              </v-col>
              <!-- comienzan direcciones -->
            </v-row>
            <v-row>
              <v-col cols="8"> </v-col>
              <v-col cols="4">
                <v-btn @click="agregarNuevaDireccion()" block depressed color="primary">
                  AGREGAR OTRA DIRECCIÓN
                </v-btn>
              </v-col>
            </v-row>
            <v-row v-for="(direccion, index) in objetoCliente.Direccion" :key="index">
              <v-col cols="12">
                <span style="color:black;font-size:30px;">DIRECCIÓN {{ index + 1 }}</span
                ><v-btn class="ml-3" @click="eliminarDireccion(index)" depressed color="error">
                  eliminar dirección {{ index + 1 }}
                </v-btn>
              </v-col>

              <v-col cols="12" xl="6">
                <v-text-field
                  @blur="$v.objetoCliente.Direccion.$each[index].direccion.$touch()"
                  @input="$v.objetoCliente.Direccion.$each[index].direccion.$touch()"
                  :error-messages="erroresDireccionDireccion(index)"
                  v-model="objetoCliente.Direccion[index].direccion"
                  dense
                  autocomplete="new"
                  label="Dirección"
                ></v-text-field>
              </v-col>
              <v-col cols="12" xl="6">
                <v-text-field
                  @blur="$v.objetoCliente.Direccion.$each[index].estado.$touch()"
                  @input="$v.objetoCliente.Direccion.$each[index].estado.$touch()"
                  :error-messages="erroresDireccionEstado(index)"
                  v-model="objetoCliente.Direccion[index].estado"
                  dense
                  autocomplete="new"
                  label="Estado"
                ></v-text-field>
              </v-col>
              <v-col cols="12" xl="6">
                <v-text-field
                  @blur="$v.objetoCliente.Direccion.$each[index].municipio.$touch()"
                  @input="$v.objetoCliente.Direccion.$each[index].municipio.$touch()"
                  :error-messages="erroresDireccionMunicipio(index)"
                  v-model="objetoCliente.Direccion[index].municipio"
                  dense
                  autocomplete="new"
                  label="Ciudad"
                ></v-text-field>
              </v-col>
              <v-col cols="12" xl="6">
                <v-text-field
                  autocomplete="new"
                  @blur="$v.objetoCliente.Direccion.$each[index].codigopostal.$touch()"
                  @input="
                    $v.objetoCliente.Direccion.$each[index].codigopostal.$touch();
                    actualizaDireccion(index);
                  "
                  :error-messages="erroresCodigoPostal(index)"
                  v-model="objetoCliente.Direccion[index].codigopostal"
                  dense
                  label="Código postal"
                ></v-text-field>
              </v-col>
              <v-col cols="12" xl="6">
                <!-- TODO  ojito aqui-->
                <v-combobox
                  class="mr-2"
                  v-model="objetoCliente.Direccion[index].colonia"
                  :items="codigosPostalesEncontrados[index]"
                  v-if="meMuestro(index)"
                  label="Colonia"
                  outlined
                  dense
                ></v-combobox>
                <v-text-field
                  @blur="$v.objetoCliente.Direccion.$each[index].colonia.$touch()"
                  @input="$v.objetoCliente.Direccion.$each[index].colonia.$touch()"
                  :error-messages="erroresDireccionColonia(index)"
                  v-else
                  autocomplete="new"
                  v-model="objetoCliente.Direccion[index].colonia"
                  dense
                  label="Colonia"
                ></v-text-field>
              </v-col>
              <v-col v-if="tipoClientex == 'Destinatarios'" cols="12" xl="6">
                <v-text-field
                  @blur="$v.objetoCliente.Direccion.$each[index].pais.$touch()"
                  @input="$v.objetoCliente.Direccion.$each[index].pais.$touch()"
                  :error-messages="erroresPais(index)"
                  v-model="objetoCliente.Direccion[index].pais"
                  dense
                  autocomplete="new"
                  label="País"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" xl="6">
                <v-select
                  :error-messages="sucursalErrors"
                  @input="$v.objetoCliente.Sucursal.$touch()"
                  @blur="$v.objetoCliente.Sucursal.$touch()"
                  :items="sucursalesList"
                  item-text="NOMBRE"
                  item-value="ID"
                  v-model="objetoCliente.Sucursal"
                  label="Sucursal"
                ></v-select>
              </v-col>
              <v-col v-if="tipoClientex != 'Destinatarios'" cols="12" xl="6">
                <v-select
                  :error-messages="descuentoErrors"
                  @input="$v.objetoCliente.Tarifa.$touch()"
                  @blur="$v.objetoCliente.Tarifa.$touch()"
                  :items="descuentosList"
                  item-text="DESCRIPCIÓN"
                  item-value="ID"
                  v-model="objetoCliente.Tarifa"
                  label="Tipo tarifa"
                ></v-select>
              </v-col>
            </v-row>
            <v-row>
              <v-col v-if="tipoClientex != 'Destinatarios'" cols="12">
                <v-select
                  :items="['-2', '-1', '0', '1', '2']"
                  v-model="objetoCliente.Tarifa_Seguro"
                  label="Tarifa seguro"
                ></v-select>
              </v-col>
            </v-row>

            <!-- //TODO organizar -->
            <!-- {{ objetoCliente }} -->
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" @click="$emit('cerrar-modal-cliente')" text>Cancelar</v-btn>
          <v-btn color="blue darken-1" @click="insertarCliente()" text>Aceptar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <ModalErrorEnAccion
      :mensajeError="mensajeErrorModalErrorEnAccion"
      :show="dialogErrorEnAccion"
      @cerrarModalEnAccion="dialogErrorEnAccion = false"
    />
    <v-overlay :value="loaderClientesInsertar">
      <v-progress-circular indeterminate size="100"></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import ModalErrorEnAccion from "@/components/modales/ModalErrorEnAccion.vue";
import { required, requiredIf } from "vuelidate/lib/validators";
import { mapActions, mapState } from "vuex";

const aliasRegex = /^(([a-záéíóúñ0-9A-ZÁÉÍÓÚÑ]+)([ ][a-záéíóúñ0-9A-ZÁÉÍÓÚÑ]+){0,})?$/;
const nombreCRegex = /^([a-zA-ZÁÉÍÓÚáéíóúñÑ]+([ ][a-zA-ZÁÉÍÓÚáéíóúñÑ]+){1,})$/;
const razonSRegex = /^(([a-zA-ZÁÉÍÓÚáéíóúÑñ0-9 !@#$%^&*/|().,´"'_+]||[\n]){0,150})$/;
const emailRegex = /^(\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,4})+)?$/;
const telefonoRegex = /^(([+]{1}[0-9]{1,4})?([0-9]{10}))?$/;
const sucursalRegex = /^([0-9]+)$/;
const descuentoRegex = /^([0-9]+)$/;

const direccionPaisRegex = /^([a-zA-ZÁÉÍÓÚáéíóúñÑäÄöÖüÜ ]{0,50})$/;
const direccionEstadoRegex = /^(([a-zA-ZÁÉÍÓÚáéíóúÑñäÄöÖüÜ ]){1,40})$/;
const direccionMunicipioRegex = /^(([a-zA-ZÁÉÍÓÚáéíóúÑñäÄöÖüÜ0-9 ().,´"'_]){1,80})$/;
const direccionCodigoPostalRegex = /^([0-9a-zA-ZÁÉÍÓÚáéíóúÑñäÄöÖüÜ -]{2,10})$/
const direccionColoniaRegex = /^(([a-zA-ZÁÉÍÓÚáéíóúÑñäÄöÖüÜ0-9 !@#$%^&*/|().,´"'_+]){1,50})$/;
const direccionDireccionRegex = /^(([a-zA-ZÁÉÍÓÚáéíóúÑñ0-9 äÄöÖüÜ!@#$%^&*/|().,´"'_+]){1,50})$/;
export default {
  components: {
    ModalErrorEnAccion
  },
  validations: {
    objetoCliente: {
      Alias: {
        aliasValida(Alias) {
          if (this.objetoCliente.Alias.length == 0 || this.objetoCliente.Alias == null) {
            return true;
          } else {
            return aliasRegex.test(Alias);
          }
        }
      },
      Nombre_Completo: {
        required,
        nombreCValida(Nombre_Completo) {
          return nombreCRegex.test(Nombre_Completo);
        }
      },
      Razon_Social: {
        razonSValida(Razon_Social) {
          return razonSRegex.test(Razon_Social);
        }
      },
      Email: {
        emailValida(Email) {
          if (this.objetoCliente.Email.length == 0 || this.objetoCliente.Email == null) {
            return true;
          } else {
            return emailRegex.test(Email);
          }
        }
      },
      Telefono: {
        required: requiredIf(function(form) {
          return this.tipoClientex == "Remitentes";
        }),
        telefonoValida(Telefono) {
          if (this.objetoCliente.Telefono.length == 0 || this.objetoCliente.Telefono == null) {
            return true;
          } else {
            return telefonoRegex.test(Telefono);
          }
        }
      },
      Sucursal: {
        required,
        sucursalValida(Sucursal) {
          return sucursalRegex.test(Sucursal);
        }
      },
      Direccion: {
        $each: {
          direccion: {
            required,
            direccionValida(direccion) {
              return direccionDireccionRegex.test(direccion);
            }
          },
          estado: {
            required,
            estadoValida(estado) {
              return direccionEstadoRegex.test(estado);
            }
          },
          municipio: {
            required,
            municipioValida(municipio) {
              return direccionMunicipioRegex.test(municipio);
            }
          },
          codigopostal: {
            required,
            codigoPostalValida(codigopostal) {
              return direccionCodigoPostalRegex.test(codigopostal);
            }
          },
          colonia: {
            required,
            coloniaValida(colonia) {
              return direccionColoniaRegex.test(colonia);
            }
          },
          pais: {
            required: requiredIf(function(form) {
              return this.tipoClientex == "Destinatarios";
            }),
            paisValida(pais) {
              if (this.tipoClientex == "Destinatarios") {
                return direccionPaisRegex.test(pais);
              } else {
                return true;
              }
            }
          }
        }
      },
      Tarifa: {
        required,
        descuentoValida(Tarifa) {
          return descuentoRegex.test(Tarifa);
        }
      }
    }
  },
  data: () => ({
    mensajeErrorModalErrorEnAccion: "",
    dialogErrorEnAccion: false,
    loaderClientesInsertar: false,
    mostrarONO: true,
    codigosPostalesEncontrados: [["2"]],
    mostrarComboxColonias: false,
    voyAInsertar: true,
    objetoCliente: {
      Alias: "",
      Nombre_Completo: "",
      Razon_Social: "",
      Tarifa_Seguro: "0",
      Direccion: [
        {
          direccion: "",
          estado: "",
          municipio: "",
          codigopostal: "",
          colonia: "",
          pais: ""
        }
      ],
      Email: "",
      Telefono: "",
      Sucursal: 1,
      Tarifa: 1
    }
  }),
  async mounted() {
    await this.getSucursales();
    await this.getTarifas();
    if (this.clientePasado.ID) {
      this.voyAInsertar = false;
      this.objetoCliente.TaxId = this.clientePasado.TAXID;
      this.objetoCliente.Alias = this.clientePasado.ALIAS;
      this.objetoCliente.Nombre_Completo = this.clientePasado.NOMBRE_COMPLETO;
      this.objetoCliente.Razon_Social = this.clientePasado.RAZON_SOCIAL;
      this.objetoCliente.Email = this.clientePasado.EMAIL;
      this.objetoCliente.Id = this.clientePasado.ID;
      this.objetoCliente.Telefono = this.clientePasado.TELEFONO;
      const indiceDeListaSucursales = this.sucursalesList.findIndex(
        element => element.NOMBRE == this.clientePasado.SUCURSAL
      );

      this.objetoCliente.Sucursal = this.sucursalesList[indiceDeListaSucursales].ID;

      if (this.tipoClientex == "Destinatarios") {
        const indiceDestinatarioEditar = this.destinatariosList.findIndex(
          element => element.ID == this.clientePasado.ID
        );
        // revisamos que exista el atributo direccion para poder copiarlo jaja
        if (this.destinatariosList[indiceDestinatarioEditar].DIRECCION) {
          var arregloDirecciones = JSON.parse(
            this.destinatariosList[indiceDestinatarioEditar].DIRECCION
          );
          var arregloColonias = JSON.parse(
            this.destinatariosList[indiceDestinatarioEditar].COLONIA
          );
          var arregloCP = JSON.parse(
            this.destinatariosList[indiceDestinatarioEditar].CODIGO_POSTAL
          );
          var arregloEstado = JSON.parse(this.destinatariosList[indiceDestinatarioEditar].ESTADO);
          var arregloMunicipio = JSON.parse(
            this.destinatariosList[indiceDestinatarioEditar].MUNICIPIO
          );
          const arregloPais = JSON.parse(this.destinatariosList[indiceDestinatarioEditar].PAIS);
          for (var k = 0; k < arregloDirecciones.length - 1; k++) {
            this.objetoCliente.Direccion.push({
              direccion: "",
              estado: "",
              municipio: "",
              codigopostal: "",
              colonia: "",
              pais: ""
            });
            this.codigosPostalesEncontrados.push(["1"]);
          }
          for (var k = 0; k < arregloDirecciones.length; k++) {
            this.objetoCliente.Direccion[k].direccion = arregloDirecciones[k];
            this.objetoCliente.Direccion[k].colonia = arregloColonias[k];
            this.objetoCliente.Direccion[k].estado = arregloEstado[k];
            this.objetoCliente.Direccion[k].municipio = arregloMunicipio[k];
            this.objetoCliente.Direccion[k].pais = arregloPais[k];
            this.objetoCliente.Direccion[k].codigopostal = arregloCP[k];
          }
        }
      } else {
        // es un cliente de tipo remitente

        this.objetoCliente.Tarifa_Seguro = this.clientePasado.TARIFA_SEGURO;
        const indiceRemitenteEditar = this.remitentesList.findIndex(
          element => element.ID == this.clientePasado.ID
        );
        if (this.remitentesList[indiceRemitenteEditar].DIRECCION) {
          var arregloDirecciones = JSON.parse(this.remitentesList[indiceRemitenteEditar].DIRECCION);
          var arregloColonias = JSON.parse(this.remitentesList[indiceRemitenteEditar].COLONIA);
          var arregloCP = JSON.parse(this.remitentesList[indiceRemitenteEditar].CODIGO_POSTAL);
          var arregloEstado = JSON.parse(this.remitentesList[indiceRemitenteEditar].ESTADO);
          var arregloMunicipio = JSON.parse(this.remitentesList[indiceRemitenteEditar].MUNICIPIO);
          for (var k = 0; k < arregloDirecciones.length - 1; k++) {
            this.objetoCliente.Direccion.push({
              direccion: "",
              estado: "",
              municipio: "",
              codigopostal: "",
              colonia: "",
              pais: ""
            });
            this.codigosPostalesEncontrados.push(["1"]);
          }
          for (var k = 0; k < arregloDirecciones.length; k++) {
            this.objetoCliente.Direccion[k].direccion = arregloDirecciones[k];
            this.objetoCliente.Direccion[k].colonia = arregloColonias[k];
            this.objetoCliente.Direccion[k].estado = arregloEstado[k];
            this.objetoCliente.Direccion[k].municipio = arregloMunicipio[k];
            this.objetoCliente.Direccion[k].codigopostal = arregloCP[k];
          }
          const indiceDescuentos = this.descuentosList.findIndex(
            element => element.DESCRIPCIÓN == this.clientePasado.TARIFA
          );

          this.objetoCliente.Tarifa = this.descuentosList[indiceDescuentos].ID;
        }
      }
    } else {
      this.voyAInsertar = true;
    }
  },
  methods: {
    ...mapActions("sucursales", ["getSucursales"]),
    ...mapActions("tarifas", ["getTarifas"]),
    ...mapActions("remitentesRegistro", ["insertRemitentes", "editRemitentes"]),
    ...mapActions("destinatarioRegistro", ["insertDestinatarios", "editDestinatarios"]),
    ...mapActions("sepomex", ["getDatosConCodigoPostal"]),
    meMuestro(index) {
      if (this.codigosPostalesEncontrados[index].length > 1) {
        return true;
      }
      return false;
    },
    async actualizaDireccion(index) {
      this.mostrarONO = false;
      this.codigosPostalesEncontrados[index] = [];
      if (this.objetoCliente.Direccion[index].codigopostal.length == 5) {
        const res = await this.getDatosConCodigoPostal(
          this.objetoCliente.Direccion[index].codigopostal
        );
        if (res[0] && res[1].length > 0) {
          if (res[1].length > 1) {
            this.mostrarONO = true;
            this.mostrarComboxColonias = true;
            res[1].forEach(element =>
              this.codigosPostalesEncontrados[index].push(element.ASENTAMIENTO)
            );
          } else {
            this.mostrarComboxColonias = false;
          }
          this.objetoCliente.Direccion[index].municipio = res[1][0].MUNICIPIO;
          this.objetoCliente.Direccion[index].estado = res[1][0].ESTADO;
          this.objetoCliente.Direccion[index].colonia = res[1][0].ASENTAMIENTO;
          this.objetoCliente.Direccion[index].pais = res[1][0].PAIS;
        }
      }
    },

    erroresDireccionColonia(index) {
      const errors = [];
      if (this.$v.objetoCliente.Direccion.$each[index].colonia.$dirty) {
        if (this.$v.objetoCliente.Direccion.$each.$iter[index].colonia.required == true) {
        } else {
          errors.push("El campo colonia es requerido");
        }
        if (this.$v.objetoCliente.Direccion.$each.$iter[index].colonia.coloniaValida == true) {
        } else {
          errors.push("El campo colonia no tiene el formato correcto");
        }

        return errors;
      }
      // si no se ha tocado el input regresaremos el arreglo vacio sin meterle nada
      else {
        return errors;
      }
    },
    erroresDireccionEstado(index) {
      const errors = [];
      if (this.$v.objetoCliente.Direccion.$each[index].estado.$dirty) {
        if (this.$v.objetoCliente.Direccion.$each.$iter[index].estado.required == true) {
        } else {
          errors.push("El campo estado es requerido");
        }
        if (this.$v.objetoCliente.Direccion.$each.$iter[index].estado.estadoValida == true) {
        } else {
          errors.push("El campo estado no tiene el formato correcto");
        }

        return errors;
      }
      // si no se ha tocado el input regresaremos el arreglo vacio sin meterle nada
      else {
        return errors;
      }
    },
    erroresDireccionMunicipio(index) {
      const errors = [];
      if (this.$v.objetoCliente.Direccion.$each[index].municipio.$dirty) {
        if (this.$v.objetoCliente.Direccion.$each.$iter[index].municipio.required == true) {
        } else {
          errors.push("El campo ciudad es requerido");
        }
        if (this.$v.objetoCliente.Direccion.$each.$iter[index].municipio.municipioValida == true) {
        } else {
          errors.push("El campo ciudad no tiene el formato correcto");
        }

        return errors;
      }
      // si no se ha tocado el input regresaremos el arreglo vacio sin meterle nada
      else {
        return errors;
      }
    },
    erroresPais(index) {
      const errors = [];
      if (this.$v.objetoCliente.Direccion.$each[index].pais.$dirty) {
        if (this.$v.objetoCliente.Direccion.$each.$iter[index].pais.required == true) {
        } else {
          errors.push("El campo país es requerido");
        }
        if (this.$v.objetoCliente.Direccion.$each.$iter[index].pais.paisValida == true) {
        } else {
          errors.push("El campo país no tiene el formato correcto");
        }

        return errors;
      }
      // si no se ha tocado el input regresaremos el arreglo vacio sin meterle nada
      else {
        return errors;
      }
    },
    erroresCodigoPostal(index) {
      const errors = [];
      if (this.$v.objetoCliente.Direccion.$each[index].codigopostal.$dirty) {
        if (this.$v.objetoCliente.Direccion.$each.$iter[index].codigopostal.required == true) {
        } else {
          errors.push("El campo código postal es requerido");
        }
        if (
          this.$v.objetoCliente.Direccion.$each.$iter[index].codigopostal.codigoPostalValida == true
        ) {
        } else {
          errors.push("El campo código postal no tiene el formato correcto");
        }

        return errors;
      }
      // si no se ha tocado el input regresaremos el arreglo vacio sin meterle nada
      else {
        return errors;
      }
    },
    erroresDireccionDireccion(index) {
      const errors = [];
      if (this.$v.objetoCliente.Direccion.$each[index].direccion.$dirty) {
        if (this.$v.objetoCliente.Direccion.$each.$iter[index].direccion.required == true) {
        } else {
          errors.push("El campo direccion es requerido");
        }
        if (this.$v.objetoCliente.Direccion.$each.$iter[index].direccion.direccionValida == true) {
        } else {
          errors.push("El campo direccion no tiene el formato correcto");
        }

        return errors;
      }
      // si no se ha tocado el input regresaremos el arreglo vacio sin meterle nada
      else {
        return errors;
      }
    },
    async agregarNuevaDireccion() {
      this.codigosPostalesEncontrados.push(["1"]);
      this.objetoCliente.Direccion.push({
        direccion: "",
        estado: "",
        municipio: "",
        codigopostal: "",
        colonia: "",
        pais: ""
      });
    },
    async eliminarDireccion(index) {
      this.objetoCliente.Direccion.splice(index, 1);
    },
    async insertarCliente() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      } else if (this.voyAInsertar) {
        // si alias es vacio o nulo lo eliminamos
        if (this.objetoCliente.Alias == null || this.objetoCliente.Alias == "") {
          delete this.objetoCliente.Alias;
        }
        if (this.tipoClientex == "Destinatarios") {
          delete this.objetoCliente.Tarifa;
          delete this.objetoCliente.Tarifa_Seguro;
          this.loaderClientesInsertar = true;
          const res = await this.insertDestinatarios(this.objetoCliente);
          if (res[0]) {
            this.$emit("mostrarDialogClienteExitoso", "Destinatario insertado con éxito");
            this.$emit("cerrar-modal-cliente");
            this.loaderClientesInsertar = false;
          } else {
            this.mensajeErrorModalErrorEnAccion = res[1];
            this.dialogErrorEnAccion = true;

            this.loaderClientesInsertar = false;
          }
        } else {
          if (this.objetoCliente.Direccion.length >= 1) {
            for (let i = 0; i < this.objetoCliente.Direccion.length; i++) {
              delete this.objetoCliente.Direccion[i].pais;
            }
          }

          this.loaderClientesInsertar = true;
          const res = await this.insertRemitentes(this.objetoCliente);
          if (res[0]) {
            this.$emit("mostrarDialogClienteExitoso", "Remitente insertado con éxito");
            this.$emit("cerrar-modal-cliente");
            this.loaderClientesInsertar = false;
          } else {
            this.mensajeErrorModalErrorEnAccion = res[1];
            this.dialogErrorEnAccion = true;

            this.loaderClientesInsertar = false;
          }
        }
      } else if (this.tipoClientex == "Destinatarios") {
        if (this.objetoCliente.Alias == null || this.objetoCliente.Alias == "") {
          delete this.objetoCliente.Alias;
        }
        delete this.objetoCliente.Tarifa;
        delete this.objetoCliente.Tarifa_Seguro;
        const res = await this.editDestinatarios(this.objetoCliente);
        if (res[0]) {
          this.$emit("mostrarDialogClienteExitoso", "Destinatario editado con éxito");
          this.$emit("cerrar-modal-cliente");
        } else {
          this.mensajeErrorModalErrorEnAccion =
            res[1].msg + " " + JSON.stringify(res[1].validacion);
          this.dialogErrorEnAccion = true;
          this.loaderClientesInsertar = false;
        }
      } else {
        if (this.objetoCliente.Alias == null || this.objetoCliente.Alias == "") {
          delete this.objetoCliente.Alias;
        }
        for (let i = 0; i < this.objetoCliente.Direccion.length; i++) {
          delete this.objetoCliente.Direccion[i].pais;
        }
        const res = await this.editRemitentes(this.objetoCliente);
        if (res[0]) {
          this.$emit("mostrarDialogClienteExitoso", "Remitente editado con éxito");
          this.$emit("cerrar-modal-cliente");
        } else {
          this.mensajeErrorModalErrorEnAccion =
            res[1].msg + " " + JSON.stringify(res[1].validacion);
          this.dialogErrorEnAccion = true;
          this.loaderClientesInsertar = false;
        }
      }
    }
  },
  props: {
    clientePasado: Object,
    show: Boolean,
    tipoClientex: String
  },
  computed: {
    ...mapState("tarifas", {
      descuentosList: state => state.descuentos
    }),
    ...mapState("sucursales", {
      sucursalesList: state => state.sucursales
    }),
    ...mapState("destinatarioRegistro", {
      destinatariosList: state => state.destinatarios,
      paginasDestinatarios: state => state.totalPaginas
    }),
    ...mapState("remitentesRegistro", {
      remitentesList: state => state.remitentes,
      paginasRemitentes: state => state.totalPaginas
    }),
    ...mapState("sepomex", {
      codigosList: state => state.datosConCodigoPostal
    }),
    aliasErrors() {
      const errors = [];
      if (!this.$v.objetoCliente.Alias.$dirty) return errors;
      !this.$v.objetoCliente.Alias.aliasValida &&
        errors.push("El campo alias no tiene el formato correcto.");
      return errors;
    },
    nombreC_Errors() {
      const errors = [];
      if (!this.$v.objetoCliente.Nombre_Completo.$dirty) return errors;
      !this.$v.objetoCliente.Nombre_Completo.required &&
        errors.push("El campo nombre completo es requerido.");
      !this.$v.objetoCliente.Nombre_Completo.nombreCValida &&
        errors.push("El campo nombre completo no tiene el formato correcto.");
      return errors;
    },
    razonS_Errors() {
      const errors = [];
      if (!this.$v.objetoCliente.Razon_Social.$dirty) return errors;
      !this.$v.objetoCliente.Razon_Social.razonSValida &&
        errors.push("El campo razón social no tiene el formato correcto.");
      return errors;
    },
    emailErrors() {
      const errors = [];
      if (!this.$v.objetoCliente.Email.$dirty) return errors;
      !this.$v.objetoCliente.Email.emailValida &&
        errors.push("El campo email no tiene el formato correcto.");
      return errors;
    },
    telefonoErrors() {
      const errors = [];
      if (!this.$v.objetoCliente.Telefono.$dirty) return errors;
      !this.$v.objetoCliente.Telefono.required && errors.push("El campo teléfono es requerido.");
      !this.$v.objetoCliente.Telefono.telefonoValida &&
        errors.push("El campo teléfono no tiene el formato correcto.");
      return errors;
    },
    sucursalErrors() {
      const errors = [];
      if (!this.$v.objetoCliente.Sucursal.$dirty) return errors;
      !this.$v.objetoCliente.Sucursal.required &&
        errors.push("El campo sucursal completo es requerido.");
      !this.$v.objetoCliente.Sucursal.sucursalValida &&
        errors.push("El campo sucursal no tiene el formato correcto.");
      return errors;
    },
    descuentoErrors() {
      const errors = [];
      if (!this.$v.objetoCliente.Tarifa.$dirty) return errors;
      !this.$v.objetoCliente.Tarifa.required && errors.push("El campo tarifa es requerido.");
      !this.$v.objetoCliente.Tarifa.descuentoValida &&
        errors.push("El campo tarifa no tiene el formato correcto.");
      return errors;
    }
  }
};
</script>

<style lang="css" scoped>
.errorsx {
  background-color: white;
  color: red;
  font-size: 13px;
  font-weight: bold;
  margin-top: -15px;
}
</style>
